import React from "react";
import { Loader2, X, Download } from "lucide-react";
import CustomAudioPlayer from "components/CustomAudioPlayer";
import { fileTypeIcons } from "utils/utilityFunctions";
import { useImageUrl } from "../hooks/useMediaUrl";

const MediaItem = ({ mediaItem, setShowImagePreview, setSelectedMedia }) => {
    const { data: mediaData, isLoading, error } = useImageUrl(mediaItem.mediaId);

    const isVideoUrl = (url) => {
        if (!url) return false;
        return (
            url.toLowerCase().endsWith(".mp4") ||
            url.toLowerCase().endsWith(".mov") ||
            url.toLowerCase().endsWith(".webm") ||
            url.toLowerCase().endsWith(".avi") ||
            /\.(mp4|mov|webm|avi)/i.test(url)
        );
    };

    const isImageUrl = (url) => {
        if (!url) return false;
        return (
            url.toLowerCase().endsWith(".jpg") ||
            url.toLowerCase().endsWith(".jpeg") ||
            url.toLowerCase().endsWith(".png") ||
            url.toLowerCase().endsWith(".gif") ||
            url.toLowerCase().endsWith(".webp") ||
            /\.(jpg|jpeg|png|gif|webp)/i.test(url)
        );
    };

    if (isLoading) {
        return (
            <div className="h-20 w-20 flex items-center justify-center">
                <Loader2 className="w-6 h-6 animate-spin text-purple-600" />
            </div>
        );
    }

    if (error || !mediaData) {
        return (
            <div className="h-20 w-20 flex items-center justify-center bg-gray-200 rounded">
                <X className="w-6 h-6 text-gray-400" />
            </div>
        );
    }

    const url = mediaData.image || mediaData.file;
    let type = mediaData.type;
    if (isVideoUrl(url)) {
        type = "video";
    } else if (isImageUrl(url)) {
        type = "image";
    }

    if (type === "audio") {
        return (
            <CustomAudioPlayer url={url} transcription={mediaData.transcription} onClick={() => {
                console.log("clicked", mediaItem);
            }} />
        );
    }

    if (type === "video" || isVideoUrl(url)) {
        return (
            <video
                src={url}
                controls
                className="rounded h-32 cursor-pointer object-cover bg-black"
            />
        );
    }

    if (type === "image" || (!type && url)) {
        return (
            <img
                src={url}
                alt="Shared media"
                className="rounded h-32 cursor-pointer object-cover border border-gray-200"
                onClick={() => {
                    setShowImagePreview(true);
                    setSelectedMedia(url);
                }}
            />
        );
    }

    // Default for documents/PDFs/other
    const fileName = url ? url.split("?")[0].split("/").pop() : "Document";
    const extension = fileName.split(".").pop().toLowerCase();
    const isViewable = ["pdf", "txt", "docx", "doc"].includes(extension);

    return (
        <div className="flex items-center gap-2">
            <div
                className={`flex items-center gap-2 p-2 bg-gray-100 rounded border border-gray-200 max-w-[200px] ${isViewable ? "cursor-pointer hover:bg-gray-200" : ""
                    } transition-colors`}
            >
                {fileTypeIcons({
                    fileType: extension,
                    className: "w-5 h-5 text-purple-600 flex-shrink-0",
                })}
                <span className="text-xs text-gray-700 truncate" title={fileName}>
                    {fileName}
                </span>
            </div>
            <a
                href={url}
                download
                className="p-2 bg-gray-100 rounded border border-gray-200 hover:bg-gray-200 text-gray-600"
                title="Download"
            >
                <Download className="w-4 h-4" />
            </a>
        </div>
    );
};

export default MediaItem;
